import {instance, onErrorFunction, onSuccessFunction} from "../../../config/axios-cnf";

export const  apiPostZoneStats = (subjectId,data,callback,error)=>{
    instance.post("/api/v2/enigoo/"+subjectId+"/zone/stats",data)
        .then((response) => callback(onSuccessFunction(response.data)))
        .catch((err) => error(onErrorFunction(err)));
}
